import { useEffect, useMemo, useState } from "react";
import { findThumbURL, findVideoURL } from "../../lib/media";

const useVideoThumbnail = ({ key, useQuery }) => {
  const [{ assets, liveAssets }] = useQuery();
  const thumb = useMemo(() => findThumbURL(assets, key), [assets, key]);
  const video = useMemo(() => findVideoURL(assets, key), [assets, key]);
  const [loaded, setLoaded] = useState(false);
  const error = useMemo(() => {
    // Error is always when the thumbnail failed to load
    return !loaded
  }, [loaded])

  useEffect(() => {
    if (liveAssets) {
      setLoaded(true)
    }
  }, [liveAssets, assets])

  return {
    errorState: [error],
    loadedState: [loaded, setLoaded],
    thumb,
    video,
  }
};

export default useVideoThumbnail;
